import { render, staticRenderFns } from "./PayrollRequestActive.vue?vue&type=template&id=62052504"
import script from "./PayrollRequestActive.vue?vue&type=script&lang=js"
export * from "./PayrollRequestActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports